export default {
  namespaced: true,
  state: () => ({
    filters: {},
    items: {},
    labels: [],
  }),

  getters: {
    /**
     * @param state
     * @return {boolean}
     */
    hasLabels(state) {
      return _.size(state.labels) > 0;
    }
  },

  mutations: {
    setItems(state, items) {
      state.items = items;
    },

    updateItems(state, items) {
      state.items = _.assignWith({}, state.items, items, (objVal, srcVal) => _.assign({}, objVal, srcVal));
    },

    updateFilters(state, {name, values}) {
      const fields = _.chain(state).get(['items', name, 'fields']).keys().value();

      const filters = _.omit(state.filters, fields);
      state.filters = _.assign(filters, values);
    },

    updateLabels(state, {name, values}) {
      const labels = _.filter(state.labels, label => label.name !== name);
      labels.push(...values);
      state.labels = labels;
    },
  },
};
